export const numberOfSentences = (str: string) => {
  const sentences = str.replace(/([.?!])\s*(?=[A-Z])/g, '$1|').split('|');
  return sentences.length;
};
